var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#d00909",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-shield-x",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.5 9-5 5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m9.5 9 5 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseError);
export default __webpack_public_path__ + "static/media/close-error.e5bdbddf31ddbe64a9b0d53be037426b.svg";
export { ForwardRef as ReactComponent };